import loadable from '@loadable/component';

/**
 * Code-split wrapper for GoogleAuthWidget — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const GoogleAuthWidget = loadable(
    /* #__LOADABLE__ */
    () => import('./GoogleAuthWidget'),
    {
        resolveComponent: (components) => components.GoogleAuthWidget,
        ssr: false,
    }
);
